module.exports = __webpack_public_path__ + "static/media/brand-5.d11f2668.png";